import webglSet from "./webglSet";
import webglStart from "./webglStart";
import Btn from "./btn";
import Reset from "./reset";
import Resize from "./resize";
import Information from "./information";

import webglTopBack from "./webglTopBack";
import webglListBack from "./webglListBack";

import detailShow from "./detailShow";
import detailChange from "./detailChange";
import detailUpdate from "./detailUpdate";
import detailIllust from "./detailIllust";

let _btn;
let _reset;
let _resize;
let _information;

let _webglset;
let _webglstart;
let _webgltopBack;
let _webgllistBack;

let _detailShow;
let _detailChange;
let _detailUpdate;
let _detailIllust;

export default class kvManager{
    constructor(param,scroll,slider,gNavi){

        this.loader = document.getElementById('p-loading');

        this.headerTitle = document.getElementById('l-header-title');
        this.headerContact = document.getElementById('l-header-contact');
        this.headerBtn = document.getElementById('l-header-btn');
        //this.headerProperty = document.getElementById('l-header-property');

        this.canvas = document.getElementById('canvas');

        this.content = document.getElementById('p-kv__content');
        this.copy = document.getElementsByClassName('js__show');
        this.btn = document.querySelector('#p-kv .c-btn');

        this.detailTrigger = document.querySelector('.js-mv-area');
        this.detail = document.getElementById('p-kv__detail');
        this.detailNumber = this.detail.querySelectorAll('.number');
        this.detailEn = this.detail.querySelectorAll('.en');
        this.detailJp = this.detail.querySelectorAll('.jp');
        this.detailText = this.detail.querySelectorAll('.text');
        // this.detailPager = this.detail.querySelectorAll('.pager');

        this.detailPrevBtn = document.getElementById('p-kv__prev');
        this.detailPrevDefault = document.getElementById('p-kv__prev-default');
        this.detailPrevHover = document.getElementById('p-kv__prev-hover');

        this.detailNextBtn = document.getElementById('p-kv__next');
        this.detailNextDefault = document.getElementById('p-kv__next-default');
        this.detailNextHover = document.getElementById('p-kv__next-hover');

        this.man = document.getElementById('p-kv-man');
        this.manSVG = document.getElementById('p-kv-man-svg');
        this.information = document.getElementById('p-kv-information');
        this.informationInner = document.getElementById('p-kv-information__inner');
        this.informationBtn = document.getElementById('p-kv-information-icon');
        this.informationFace = document.getElementById('p-kv-information__face');

        this.close = document.getElementById('p-kv-close');
        this.back = document.getElementById('p-kv-back');
        this.scrolldown = document.getElementById('p-kv-scrolldown');
        this.cover = document.getElementById('p-kv-cover');

        this.pager = document.getElementById('p-kv-pager');
        this.pagerNow = document.getElementById('p-kv-pager-now');
        this.shuffle = document.getElementById('p-kv-shuffletext');

        this.detailContent = [];
        for(let i=0; this.detail.children.length>i; i++) {
            this.detailContent[i] = document.getElementById('p-kv__detail'+i);
        }

        this.shuffleRepeat;

        this.status = {
            index : 0,
            comp : false,
            animation : false,
            rendering : false,
            information:false,
            webglAnimation:false,
            reload:false,
            remainingOld:18,
            remainingNew:18,
            IE : document.querySelector('html.windows') != null || document.querySelector('html.edge') != null?true:false,
            _x:0,
            _y:0,
        }

        this.max = this.detailContent.length - 1;

        this.param = param;
        this.scroll = scroll;
        this.slider = slider;
        this.gNavi = gNavi;

        this.canvas = {
            el:'',
            ctx:'',
            length:'',
            count:0,
            width:'',
            height:'',
            i : 0
        }
        this.srcList = [];
        this.imgList = [];

        _btn = new Btn(this);
        _reset = new Reset(this);
        _resize = new Resize(this);
        _information = new Information(this);

        _webglset = new webglSet(this);
        _webglstart = new webglStart(this,this.scroll);
        _webgltopBack = new webglTopBack(this);
        _webgllistBack = new webglListBack(this,_btn);

        _detailUpdate = new detailUpdate(this);
        _detailIllust = new detailIllust(this);

        _detailShow = new detailShow(this,_detailUpdate,_btn,_resize,_reset)
        _detailChange = new detailChange(this,_detailShow);

        //easing
        this.easeBack = Back.easeOut.config(1);

    }
    init() {

        let _w = window.innerWidth;
        let _h = window.innerHeight;
        this.resize(_w,_h);

        if(Useragnt.mobile || Useragnt.tablet) {
            let _count = 0;
            let imgList = [];
            for (let i = 0; i < 18; ++i) {
                imgList[i] = new Image();
                imgList[i].src = 'assets/img/mv/item_sp/item_'+i+'.jpg';
                imgList[i].onload = () => {
                    loaded();
                }
            }
            let loaded =()=> {
                if (++_count === 18) {
                    this.loaded();
                }
            }
        }else{
            this.loaded();
        }

        /* ---------------------------------------------------

         -- copy set

        --------------------------------------------------- */

        TweenMax.set(this.copy, {
            display: 'block',
            y: '101%',
        });
        TweenMax.set(this.btn, {
            display: 'block',
            opacity: 0,
            y: '50px'
        });

        /* ---------------------------------------------------

         -- event

        --------------------------------------------------- */

        //ボタン
        this.btn.addEventListener('click', () => {
            this.param.screenType = 'full';
            this.status.webglAnimation = true;
            if(Useragnt.mobile || Useragnt.tablet) {
                if(this.shuffleRepeat) {
                    this.shuffleRepeat.pause();
                }
                TweenMax.to(this.shuffle, 0.3 , {
                    display: 'none',
                    opacity: 0,
                });
                TweenMax.set(this.pager, {
                    opacity: 0,
                    display: 'none',
                });
                _detailUpdate.remainingSet();
            }
            TweenLite.to(window, 0, {
                scrollTo:1,
                onComplete:()=>{
                    document.getElementById('l-root').style.transform = 'translate3d(0,0,0)';
                    _webglstart.set();
                    if(!this.scroll.status.rendering){
                        this.scroll.status.rendering = true;
                        window.mv_main.resumeRender();
                    }
                    if(!Useragnt.mobile && !Useragnt.tablet) {
                        let srcList = [];
                        let imgList = [];
                        srcList[0] = 'assets/img/top/kv/1/b-bg.jpg';
                        srcList[1] = 'assets/img/top/kv/2/b-bg.jpg';
                        srcList[2] = 'assets/img/top/kv/4/b-bg.jpg';
                        srcList[3] = 'assets/img/top/kv/1/b-bg.jpg';
                        srcList[4] = 'assets/img/top/kv/14/b-bg.jpg';
                        srcList[5] = 'assets/img/top/kv/15/b-bg.jpg';
                        srcList[6] = 'assets/img/top/kv/16/b-bg.png';
                        srcList[7] = 'assets/img/top/kv/17/b-bg.jpg';
                        srcList[8] = 'assets/img/top/kv/18/b-bg.jpg';
                        for (let i = 0; i < srcList.length; ++i) {
                            imgList[i] = new Image();
                            imgList[i].src = srcList[i];
                        }
                    }
                }
            });
        }, false);

        //reload
        window.mv_main.onReload = () => {
            this.status.reload = true;
            this.shuffleRepeat.pause();
            TweenMax.to(this.shuffle, 0.3 , {
                opacity: 0,
                display: 'none',
            });
            TweenMax.to(this.pager, .3, {
                scale: .8,
                opacity: 0,
                display: 'none',
                ease: this.easeBack,
            });
        }

        //詳細ボタン
        this.detailTrigger.onclick = () => {

            if(this.status.animation) return;
            this.status.animation = true;
            let _delay = '4e3';
            if(Useragnt.mobile || Useragnt.tablet){ //sp
                _delay = 1500;
                setTimeout(() => {
                    if (this.status.reload) {
                        this.status.reload = false;
                        this.status.animation = false;
                        return;
                    }
                },_delay);
            }else{ //pc
                this.status.index = window.mv_main.getSelectedItemId() - 1;
                _detailUpdate.set();
                let _w = window.innerWidth;
                let _h = window.innerHeight;
                _resize.set(_w,_h);
                this.scroll.resize(_w,_h);
                _btn.backBtn('hide');
                setTimeout(() => {
                    _detailShow.set('next');
                    _detailShow.show('detail','next');
                },_delay);
            }
        }

        window.mv_main.onFixedDetail = () => {
            if(Useragnt.mobile || Useragnt.tablet) {
                this.status.index = window.mv_main.getSelectedItemId() - 1;
                _detailShow.set('next');
                _detailShow.show('detail','next');
            }
        }

        //Prevボタン
        this.detailPrevBtn.onclick = () => {
            if(this.status.animation) return;
            this.status.animation = true;
            if(this.status.index > 0){
                this.status.index --;
            }else{
                this.status.index = 17;
            }
            _btn.hide('prev');
            _detailChange.set('prev');
        }

        //Nextボタン
        this.detailNextBtn.onclick = () => {
            if(this.status.animation) return;
            this.status.animation = true;
            if(this.status.index < this.max){
                this.status.index ++;
            }else{
                this.status.index = 0;
            }
            _btn.hide('next');
            _detailChange.set('next');
        }

        //profile Hover
        this.manSVG.addEventListener('mouseenter', () => {
            if(this.param.screenType  === 'full' || Useragnt.mobile || Useragnt.tablet) return;
            _information.btnShow();
        }, false);
        this.manSVG.addEventListener('mouseleave', () => {
            _information.btnHide();
            this.status.information = false;
            _information.hide();
        }, false);

        this.manSVG.addEventListener('click', () => {
            //if(Useragnt.mobile || Useragnt.tablet) return;
            if(this.status.information){
                this.status.information = false;
                _information.hide();
            }else{
                this.status.information = true;
                _information.show();
            }
        }, false);

        // this.informationBtn.addEventListener('click', () => {
        //     if(Useragnt.pc) return;
        //     this.status.information = true;
        //     _information.show();
        // }, false);

        this.information.addEventListener('click', () => {
            if(Useragnt.pc) return;
            this.status.information = false;
            _information.hide();
        }, false);


        //詳細閉じるボタン
        this.close.addEventListener('click', () => {
            if(this.status.animation) return;
            _webgllistBack.set();
        }, false);

        //TOPへ戻るボタン
        this.back.addEventListener('click', () => {
            if(this.status.animation) return;
            this.status.rendering = false;
            this.param.screenType = 'normal';
            let _w = window.innerWidth;
            let _h = window.innerHeight;
            this.scroll.resize(_w,_h);
            _reset.set();
            _webgltopBack.set();
        }, false);

    }

    /* ---------------------------------------------------

　　　-- 停止

    --------------------------------------------------- */

    //window.mv_main.stopRender();

    /* ---------------------------------------------------

　　　-- 再開

    --------------------------------------------------- */

    //window.mv_main.resumeRender();

    loaded(){

        window.mv_main.setup({
            onProgress: function (pct) {
                console.log(pct);
            },
            onComplete: () => {
                setTimeout(() => {
                    window.mv_main.start();
                    this.scroll.status.start = true;
                    this.slider.init();
                    _webglset.set();
                    let _w = window.innerWidth;
                    let _h = window.innerHeight;
                    this.scroll.resize(_w,_h);
                    this.gNavi.resize(_w,_h);
                },'3e3');
            }
        });

    }

    resize(_w,_h){

        _resize.set(_w,_h);

    }

    mouse(mouse,para3d){

        TweenMax.set(this.informationBtn, {
            x: mouse.x,
            y: mouse.y,
        });

    }

    render(){

        if(this.status.webglAnimation) return;

        if(Useragnt.mobile || Useragnt.tablet){
            this.status.remainingNew = window.mv_main.itemNum;
            if(this.status.remainingOld === this.status.remainingNew || window.mv_main.itemNum === 18) return;
            this.status.remainingOld = window.mv_main.itemNum;
            _detailUpdate.remaining();
        }

        if(!this.status.rendering || Useragnt.mobile || Useragnt.tablet) return;
        _detailIllust.render();

    }

    canvasSet(){

        _detailIllust.set();

    }

    canvasStart(){

        _detailIllust.start();

    }

}